import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import MethodTypeItem from '../method-type-item';
import cryptoCurenciesImages from 'common/utils/import-cryptocurrencies-images.js'
import mmsLogo from 'assets/images/payment/payment-methods/mms_logo.svg'
import paypalSmallLogo from 'assets/images/payment/paypal-small-logo.svg'
import { currencies } from 'common/utils/import-cryptocurrencies-images.js'
import { getSiteName } from 'common/utils/helper';

const MethodsWrapperByTypes = ({
   type, // credit_cards , pay_by_bank , crypto , mms_wallet , paypal
   isNextApp,
   avaliablePaymentMethods,
   defaultCandidatePaymentOptions,
   primaryColor,
   showOptionsType = '',
}) => {
   const [isShowMore, setIsShowMore] = useState(false)

   const SORTED_CREDIT_CARD_TYPES = [
      {
         type: 'visa_card',
         title: 'Visa',
         imageSrc: '',
      },
      {
         type: 'master_card',
         title: 'Mastercard',
         imageSrc: '',
      },
      {
         type: 'maestro_card',
         title: 'Maestro',
         imageSrc: '',
      },
      {
         type: 'visa_debit',
         title: 'Visa debit',
         imageSrc: '',
      },
      {
         type: 'jcb_card',
         title: 'JCB',
         imageSrc: '',
      },
      {
         type: 'discover_card',
         title: 'Discover',
         imageSrc: '',
      },
      {
         type: 'diners_club_international_card',
         title: 'Diners Club',
         imageSrc: '',
      },
   ]

   const getCryptoPaymentsCurrecies = () => {
      if(defaultCandidatePaymentOptions?.crypto?.curency?.length) {
         return defaultCandidatePaymentOptions.crypto.curency
      }
      if(defaultCandidatePaymentOptions?.segpay_crypto?.currency?.length) {
         return defaultCandidatePaymentOptions.segpay_crypto.currency
      }
   }

   const PARENT_ITEM_PROPS_BY_TYPES = {
      credit_cards: {
         title: 'Credit cards',
         isShowMoreLessItem: true,
         iconName: 'payment-card',
         methodsList: SORTED_CREDIT_CARD_TYPES,
      },
      pay_by_bank: {
         title: 'Pay by Bank (EU)',
         iconName: 'pay-by-bank',
      },
      crypto: {
         title: 'Crypto payments',
         isShowMoreLessItem: Boolean(getCryptoPaymentsCurrecies()),
         imageSrc: cryptoCurenciesImages.crypto,
         methodsList: currencies,
      },
      mms_wallet: {
         title: getSiteName() + ' Wallet',
         imageSrc: mmsLogo,
      },
      paypal: {
         title: 'PayPal',
         imageSrc: paypalSmallLogo,
         hideBottomBorder: true,
      },
   }

   const isCriptoCurrencies = 'crypto' === type

   const soredMethodsList = useMemo(() => {
      if(!PARENT_ITEM_PROPS_BY_TYPES[type]?.methodsList) {
         return []
      }


      if(isCriptoCurrencies) {
         const defaultCurrencies = getCryptoPaymentsCurrecies()
         if(!defaultCurrencies) {
            return []
         }
         return PARENT_ITEM_PROPS_BY_TYPES[type].methodsList.filter(item => {
            return defaultCurrencies.includes(item.currency)
         })
      }

      return PARENT_ITEM_PROPS_BY_TYPES[type].methodsList.filter(item => {
         return avaliablePaymentMethods.includes(item.type)
      })

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [avaliablePaymentMethods])

   useEffect(() => {
      if(!!showOptionsType && !isShowMore && showOptionsType === type) {
         onShowLessMethods(true)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [showOptionsType])
   
   const onShowLessMethods = (bool) => {
      if(bool) {
         setTimeout(() => {
            const wrapper = document.getElementById('available-payment-methods')
            if(wrapper) {
               wrapper.scrollIntoView({ behavior: 'smooth' })
            }
         }, 10)
      }
      setIsShowMore(bool)
   } 

   return (
      <div
         id='available-payment-methods'
         className='w-full flex flex-col'
      >
         <MethodTypeItem
            { ...PARENT_ITEM_PROPS_BY_TYPES[type] }
            isNextApp={ isNextApp }
            isShowMore={ isShowMore }
            onClick={ () => onShowLessMethods(!isShowMore) }
            isParentItem
            soredMethodsList={ soredMethodsList }
            isCryptoCurrency={ isCriptoCurrencies }
            primaryColor={ primaryColor }
         />
         {
            isShowMore && soredMethodsList && (
               <div
                  className='w-full flex flex-col bg-gray-50 dark:bg-gray-dark-50'
               >
                  {
                     soredMethodsList.map(item => {

                        return (
                           <MethodTypeItem
                              key={ isCriptoCurrencies ? item.value : item.type }
                              title={ item.title }
                              isNextApp={ isNextApp }
                              methodType={ isCriptoCurrencies ? item.value : item.type }
                              isCryptoCurrency={ isCriptoCurrencies }
                              primaryColor={ primaryColor }
                           />
                        )
                     })
                  }
               </div>
            )
         }
      </div>
   )
}

MethodsWrapperByTypes.propTypes = {
   type: PropTypes.string,
   isNextApp: PropTypes.bool,
   avaliablePaymentMethods: PropTypes.array,
   defaultCandidatePaymentOptions: PropTypes.object,
   primaryColor: PropTypes.string,
   showOptionsType: PropTypes.string,
}

export default MethodsWrapperByTypes;
